import { useEffect, useState } from 'react';
import { api } from '../api/client';
import type { ScenarioBudget } from '../types';

/**
 * Scénario de lecture par défaut : le **socle budgétaire**.
 *
 * Le tronc seul (« décisions arrêtées ») ne dit pas le budget — les mois à
 * venir n'y sont que le report de la dernière valeur en vigueur. Le budget en
 * l'état, c'est le socle : les décisions plus les hypothèses retenues. Toutes
 * les vues s'ouvrent donc dessus, et « Décidé seulement » devient une lecture
 * particulière, à demander explicitement.
 *
 * Rend `undefined` tant que le socle n'est pas connu : les pages attendent
 * cette valeur avant de charger leur grille, pour ne pas afficher un instant
 * des chiffres qui ne sont pas ceux du budget.
 */
export function useSocle(): number | null | undefined {
  const [socle, setSocle] = useState<number | null | undefined>(undefined);
  useEffect(() => {
    api.get<ScenarioBudget[]>('/scenarios')
      .then((scs) => setSocle(scs.find((s) => s.socle && !s.archive)?.id ?? null))
      .catch(() => setSocle(null)); // à défaut, lecture sur les décisions seules
  }, []);
  return socle;
}
